module.exports = __webpack_public_path__ + "static/media/icon_copy.cae6f91b.svg";